import React from "react";
import "./BottomSheet.css";

export default function BottomSheet({ isOpen, onClose, children }) {
    return (
        <>
            {/* Overlay */}
            {isOpen && <div className="overlay" onClick={onClose}></div>}

            {/* Sheet */}
            <div className={`bottom-sheet ${isOpen ? "open" : ""}`}>
                <div className="sheet-content">
                    <div className="sheet-header">
                        <div className="sheet-handle"></div>
                    </div>
                    <div className="sheet-body">
                        {children}
                    </div>
                </div>
            </div>
        </>
    );
}
